export default () => {
  return (
    <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.5 9L0.25 0.75H16.75L8.5 9Z" fill="black"/>
    </svg>
  )
}